// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useTerminateRegistrarService: () => UseMutationResult<
  void,
  string,
  { registrarServiceCid: ContractId<RegistrarService> }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['terminateRegistryRegistrarService', ledgerApi],
    mutationFn: async ({ registrarServiceCid }) => {
      return ledgerApi.terminateRegistryRegistrarService(registrarServiceCid, party);
    },
  });
};

export default useTerminateRegistrarService;
